/*
 * @Author: zl
 * @Date: 2022-04-15 16:32:31
 * @LastEditTime: 2022-04-15 16:34:45
 * @LastEditors: zl
 * @Description: 规划图接口
 */
import request from '../request'

/**
 * @description: 规划图 - 列表分页接口
 * @author: 崔北超
 */
export const selectPlanMap = function (data) {
    return request({
        url: '/busFileSummary/selectPlanMap',
        method: 'post',
        data
    })
}

/**
 * @description: 规划图 - 作废
 * @author: 崔北超
 */
export const planMapCancel = function (data) {
    return request({
        url: '/busFileSummary/planMapCancel',
        method: 'post',
        data
    })
}